import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { PreviewBody } from "@/components/shapes/shared/card-preview-parts";
import { Icons } from "@/components/ui/icons";
import { useT } from "@/i18n";
import { framesGithubMessages } from "@/i18n/messages/frames-github";
import { CommitsSection } from "./commits-section";
import { commitsFrom, pullRequestsFrom } from "./github-content";
import { PrSection } from "./pr-section";

const MAX_ROWS = 3;

/** A repository: the branch and its last three pull requests or commits. */
export function GithubCardPreview({ source, density }: CardPreviewProps) {
  const t = useT(framesGithubMessages);
  const branch = typeof source.branch === "string" ? source.branch : "";
  const prs = pullRequestsFrom(source.pr).slice(0, MAX_ROWS);
  const commits = commitsFrom(source.commits).slice(0, MAX_ROWS - prs.length);
  return (
    <PreviewBody density={density} cap="max-h-[15em]" className="gap-[0.3em]">
      {branch && (
        <p
          className="flex shrink-0 items-center gap-[0.45em] text-[0.86em] text-card-muted"
          data-testid="github-card-branch"
        >
          <Icons.GitBranch className="h-[1.1em] w-[1.1em]" aria-hidden="true" />
          <span className="truncate">{branch}</span>
        </p>
      )}
      <PrSection prs={prs} linked={false} />
      <CommitsSection commits={commits} />
      {!prs.length && !commits.length && (
        <p className="text-card-muted">{t("cardEmpty")}</p>
      )}
    </PreviewBody>
  );
}
